import { format, parse } from 'date-fns';

const getYm01 = (ym) => {
    
  let year = parseInt(ym.substring(0, 4));
  let month = parseInt(ym.substring(6,7));
  
  let ym01 = year + '-' + month.toString().padStart(2, "0") + '-01';

  return ym01;
};


var dateEditor = function(cell, onRendered, success, cancel, editorParams){
  console.log(cell._cell.value);
  //cell - the cell component for the editable cell
  //onRendered - function to call when the editor has been rendered
  //success - function to call to pass the successfuly updated value to Tabulator
  //cancel - function to call to abort the edit and return to a normal cell
  //editorParams - params object passed into the editorParams column definition property

  //create and style editor
  var editor = document.createElement("input");

  editor.setAttribute("type", "date");

  //create and style input
  editor.style.padding = "3px";
  editor.style.width = "100%";
  editor.style.boxSizing = "border-box";

  //Set value of editor to the current value of the cell
  if (cell.getValue() != undefined)
    editor.value = format(parse(cell.getValue(), 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd')
  else
    editor.value = "";

  //set focus on the select box when the editor is selected (timeout allows for editor to be added to DOM)
  onRendered(function(){
      editor.focus();
      editor.style.css = "100%";
  });

  //when the value has been set, trigger the cell to update
  function successFunc(){
    if (editor.value != "")
      success(format(parse(editor.value, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'));
    else if((cell._cell.value!='')&&(cell._cell.value!=null)){
      success(format(parse(cell._cell.value, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'));
    }
    else
      success(cell._cell.value);
  }

  editor.addEventListener("change", successFunc);
  editor.addEventListener("blur", successFunc);

  //return the editor element
  return editor;
};

const cellFocusEditor = function(cell, onRendered, success, cancel, editorParams){
  
  //create and style input
  let input = document.createElement("input");

  input.setAttribute("type", "text");

  input.style.padding = "4px";
  input.style.width = "100%";
  input.style.boxSizing = "border-box";

  input.value = cell.getValue();

  onRendered(function () {
      input.focus();
      input.select();
      input.style.height = "100%";
  });

  function successFunc(){
    success(input.value);
  }

  function keyHandlerFunc(e){
    if (e.keyCode == 27)
      cancel(input.value);
    //console.log(e);
  }

  //submit new value on blur or change
  input.addEventListener("change", successFunc);
  input.addEventListener("blur", successFunc);
  input.addEventListener("keyup", keyHandlerFunc);

  return input;
};


const cellselectEditor = function(cell, onRendered, success, cancel, editorParams, currentValue){
  console.log('editorParams: ', editorParams);
  console.log('editorParams: ', editorParams.length);
  console.log('currentValue: ', currentValue);

  // var  values = ["1: Supply not Received", "2: Inadequate Supply", "3: Sudden Increase of Demand"];
  var time = Math.floor(Math.random()*1000);
  // console.log('time: ', time);
    
    var select = document.createElement("select");
    select.name = "id"+time;//"pets";
    select.id = "name"+time;//"pets"
 
    select.style.padding = "5px";
    select.style.width = "100%";
    select.style.boxSizing = "border-box";

    // for (const val of values)
    for (const val of editorParams)
    {
        var option = document.createElement("option");
        option.value = val;
        option.text = val;//.charAt(0).toUpperCase() + val.slice(1);
        select.appendChild(option);
    }
    
    function successFunc(){
      success(select.value);
    }

    onRendered(function () {
      // dd.setAttribute("data-previousvalue", dd.value);
      select.focus();
      //select.select();
      select.style.height = "100%";
      select.value = currentValue;//"3: Sudden Increase of Demand";
  });

  // function keyHandlerFunc(e){
  //   if (e.keyCode == 27)
  //     cancel(select.value);
  //   //console.log(e);
  // }

  //submit new value on blur or change
  select.addEventListener("change", successFunc);

    return select;

  // //create and style input
  // let input = document.createElement("inpur");

  // input.setAttribute("type", "text");

  // input.style.padding = "4px";
  // input.style.width = "100%";
  // input.style.boxSizing = "border-box";

  // input.value = cell.getValue();

  // onRendered(function () {
  //     input.focus();
  //     input.select();
  //     input.style.height = "100%";
  // });

  // function successFunc(){
  //   success(input.value);
  // }

  // function keyHandlerFunc(e){
  //   if (e.keyCode == 27)
  //     cancel(input.value);
  //   //console.log(e);
  // }

  // //submit new value on blur or change
  // input.addEventListener("change", successFunc);
  // input.addEventListener("blur", successFunc);
  // input.addEventListener("keyup", keyHandlerFunc);

  // return input;

}

const getDefaultMonthYear = () => {
  let retValue = {};
  let currDate = new Date();
  let defaultYear = currDate.getFullYear();
  let defaultMonthId = currDate.getMonth();
  
  //0=jan
  if (defaultMonthId == 0) {
    defaultYear = defaultYear - 1;
    defaultMonthId = 12;
  } else {
    defaultMonthId = defaultMonthId;
  }
  
  retValue = {defaultYear:defaultYear,defaultMonthId:defaultMonthId};
  return retValue;
};

const getDefaultQuarterYear = () => {


  let retValue = {};
  let currDate = new Date();
  let defaultYear = currDate.getFullYear();
  let defaultMonthId = currDate.getMonth();
  
  //0=jan
  if (defaultMonthId >= 0 && defaultMonthId <= 2 ) {
    defaultYear = defaultYear - 1;
    defaultMonthId = 12;
  }else if (defaultMonthId >= 3 && defaultMonthId <= 5 ) {
    //defaultYear = defaultYear - 1;
    defaultMonthId = 3;
  } else if (defaultMonthId >= 6 && defaultMonthId <= 8 ) {
    defaultMonthId = 6;
  } else if (defaultMonthId >= 9 && defaultMonthId <= 11 ) {
    defaultMonthId = 9;
  } 
  
  retValue = {defaultYear:defaultYear,defaultMonthId:defaultMonthId};
  return retValue;

 
};

const getDefaultCurrentQuarterYear = () => {
  let retValue = {};
  let currDate = new Date();
  let defaultYear = currDate.getFullYear();
  let defaultMonthId = currDate.getMonth();

  // Set default month ID
  if (defaultMonthId >= 0 && defaultMonthId <= 2) {
    defaultMonthId = 3; 
  } else if (defaultMonthId >= 3 && defaultMonthId <= 5) {
    defaultMonthId = 6; 
  } else if (defaultMonthId >= 6 && defaultMonthId <= 8) {
    defaultMonthId = 9; 
  } else if (defaultMonthId >= 9 && defaultMonthId <= 11) {
    defaultMonthId = 12; 
  }

  retValue = { defaultYear: defaultYear, defaultMonthId: defaultMonthId }; // Set the properties in retValue
  return retValue;
};
 
const getAllFacilityList = () => {
  let retList = {};
  let Facility_List = JSON.parse(localStorage.getItem("FacilityList"));
  retList = [...new Map(Facility_List.map((item) => [item["id"], item])).values()];
  return retList;
};


const getARVFacilityList = () => {
  let ItemGroupId = 3; //ARV ItemGroupId
  let Facility_List = JSON.parse(localStorage.getItem("FacilityList"));

  // console.log('aaaaaaa ItemGroupId: ', ItemGroupId);
  // console.log('aaaaaaa Facility_List: ', Facility_List);
  
  let retList = {};
  retList = Facility_List.filter(element => element.ItemGroupId === ItemGroupId); 
  // console.log('aaaaaa  group wise facility list', retList);

  return retList;
};


const getLabFacilityList = () => {
  let ItemGroupId = 12; //LAB ItemGroupId
  let Facility_List = JSON.parse(localStorage.getItem("FacilityList"));

  // console.log('aaaaaaa ItemGroupId: ', ItemGroupId);
  // console.log('aaaaaaa Facility_List: ', Facility_List);
  
  let retList = {};
  retList = Facility_List.filter(element => element.ItemGroupId === ItemGroupId); 
  // console.log('aaaaaa  group wise facility list', retList);

  return retList;
};


const getFacilityListByGroup = (ItemGroupId) => {
  let Facility_List = JSON.parse(localStorage.getItem("FacilityList"));

  // console.log('aaaaaaa ItemGroupId: ', ItemGroupId);
  // console.log('aaaaaaa Facility_List: ', Facility_List);
  
  let retList = {};
  retList = Facility_List.filter(element => element.ItemGroupId == ItemGroupId);
  // console.log('aaaaaa  group wise facility list', retList);

  return retList;
};


const getWarehouseListByGroup = (ItemGroupId) => {
  let Warehouse_List = JSON.parse(localStorage.getItem("WarehouseList"));

  // console.log('aaaaaaa ItemGroupId: ', ItemGroupId);
  // console.log('aaaaaaa Facility_List: ', Facility_List);
  
  let retList = {};
  retList = Warehouse_List.filter(element => element.ItemGroupId == ItemGroupId);
  // console.log('aaaaaa  group wise facility list', retList);

  return retList;
};

const getNationalMOSRangeListByGroup = (ItemGroupId) => {
  let MOSRange_List = JSON.parse(localStorage.getItem("MosTypelist"));

  // console.log('aaaaaaa ItemGroupId: ', ItemGroupId);
  // console.log('aaaaaaa MOSRange_List: ', MOSRange_List);
  
  let retList = {};
  retList = MOSRange_List.filter(element => element.ItemGroupId == ItemGroupId);
  // console.log('aaaaaa  group wise facility list', retList);

  return retList;
};

export { getYm01, cellFocusEditor, dateEditor, getDefaultMonthYear, getDefaultQuarterYear, getDefaultCurrentQuarterYear, getAllFacilityList, getARVFacilityList,getLabFacilityList,getFacilityListByGroup,getWarehouseListByGroup,getNationalMOSRangeListByGroup,cellselectEditor };
